import { App } from 'vue'
import { formatToDateTime } from './date'
import { errorCodeLocalesV2 } from './locales'
import { isExternal } from './is'

// 合并函数
export const compose = (...args: Array<(e: any) => void>) => {
  return (value: any) => args.reverse().reduce((v, fn) => {
    fn(v)
    return v
  }, value)
}

export const withInstall = <T>(component: T, alias?: string) => {
  const comp = component as any
  comp.install = (app: App) => {
    app.component(comp.name || comp.displayName, component)
    if (alias) {
      app.config.globalProperties[alias] = component
    }
  }
  return component as T & Plugin
}

// 移除对象中的空属性
export const removeEmpty = (obj: any) => {
  Object.keys(obj).forEach((key) =>
    (obj[key] === null || obj[key] === undefined || obj[key].length === 0 ||
      obj[key] === '' || JSON.stringify(obj[key]) === '{}') && delete obj[key])
  return obj
}

export function formatLargeNumber(value: number): string {
  if (value < 1000) {
    return value.toString()
  } else if (value < 10000) {
    const formattedValue = (value / 1000).toFixed(1)
    return formattedValue.replace(/\.0$/, '') + 'K'
  } else if (value < 1000000) {
    const formattedValue = (value / 1000).toFixed(0)
    return formattedValue + 'K'
  } else {
    const formattedValue = (value / 1000000).toFixed(1)
    return formattedValue.replace(/\.0$/, '') + 'M'
  }
}

/**
 * 切割文件名版本-V2
 * 为兼容非资源文件命名
 * @param path
 * @returns
 */
export const splitFileNameV2 = (path: string) => {
  let fileArr: string | any[] = []
  let fileName = ''
  let suffix = ''
  // 判断是否为外链接地址，或者全路径地址
  // 是则提取文件名+后缀
  if (isExternal(path) || path.split('/').length > 1) {
    const tempArr = path.split('/')
    fileName = tempArr[tempArr.length - 1]
  } else {
    fileName = path
  }
  fileArr = fileName.split('.')
  if (fileArr.length >= 3) {
    const validSuffixArr = ['mp3', 'wav', 'ogg', 'aac', 'wma', 'flac', 'm4a', 'ac3', 'amr',
      'mp4', 'mov', 'avi', 'wmv', 'flv', 'mkv', 'mpg', 'mpeg',
      'lrc', 'unity3d', 'txt', 'json']
    if (validSuffixArr.includes(fileArr[fileArr.length - 2])) {
      suffix = fileArr[fileArr.length - 2] + '.' + fileArr[fileArr.length - 1]
    } else {
      suffix = fileArr[fileArr.length - 1]
    }
  } else {
    suffix = fileArr[fileArr.length - 1]
  }
  const prefix = fileName.split('.' + suffix)[0]
  console.log('suffix && prefix', suffix, prefix)
  return {
    prefix,
    suffix
  }
}

export default {
  install: (app: App) => {
    app.config.globalProperties.$errorCodeLocales = errorCodeLocalesV2
    app.config.globalProperties.$formatToDateTime = formatToDateTime
    app.config.globalProperties.$formatLargeNumber = formatLargeNumber
  }
}

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $errorCodeLocales: typeof errorCodeLocalesV2
    $formatToDateTime: typeof formatToDateTime
    $formatLargeNumber: typeof formatLargeNumber
  }
}
